// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q2/2022ipm/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取区域
const getAreas = () => {
  return http.get(`${urlPrefix}getAreas`);
};

const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};


export { getBaseInfo, getAreas, save };
